<template>
  <page-outline 
    :title="activateSpinner ? '' : $t('Webheader.company')"
    :show-filter="true"
    :show-refresh="true"
    :show-extract="true"
    :filter-expanded="displayFilter"
    :refresh-disabled="activateSpinner"
    :extract-disabled="activateSpinner"
    @toggle-filter="toggleFilter"
    @refresh="refreshInbox"
    @extract="exportCompany">
    
    <template slot="secondaryActions">
      <!-- Section de filtres -->
      <div>
        <b-collapse v-model="displayFilter" class="mt-3">
          <div class="bg-white border rounded p-3">
            <b-row class="g-3 mb-3">
              <!-- Filtre active -->
              <b-col sm="6" lg="4">
                <div class="bg-light border rounded p-3">
                  <label for="filter-active" class="form-label font-weight-bold text-muted mb-2">
                    <i class="fa-solid fa-toggle-on mr-2"></i>
                    {{ $t('administration.active') }}
                  </label>
                  <select
                    id="filter-active"
                    v-model="active"
                    @input="delayApplyFilter"
                    class="form-control"
                    :aria-label="$t('filter.search_by') + ' ' + $t('administration.active')">
                    <option value="">{{ $t('administration.select_activity') }}</option>
                    <option value="0">{{ $t('administration.no') }}</option>
                    <option value="1">{{ $t('administration.in_prgrss') }}</option>
                    <option value="2">{{ $t('administration.yes') }}</option>
                  </select>
                </div>
              </b-col>
              
              <!-- Filtre identifiant -->
              <b-col sm="6" lg="4">
                <div class="bg-light border rounded p-3">
                  <label for="filter-identifier" class="form-label font-weight-bold text-muted mb-2">
                    <i class="fa-solid fa-id-card mr-2"></i>
                    {{ $t('administration.user_login') }}
                  </label>
                  <input
                    id="filter-identifier"
                    v-model="identifier"
                    @input="delayApplyFilter"
                    type="text"
                    class="form-control"
                    :placeholder="$t('administration.enter_id')"
                    :aria-label="$t('filter.search_by') + ' ' + $t('administration.user_login')">
                </div>
              </b-col>
              
              <!-- Filtre name -->
              <b-col sm="6" lg="4">
                <div class="bg-light border rounded p-3">
                  <label for="filter-name" class="form-label font-weight-bold text-muted mb-2">
                    <i class="fa-solid fa-building mr-2"></i>
                    {{ $t('administration.user') }}
                  </label>
                  <input
                    id="filter-name"
                    v-model="name"
                    @input="delayApplyFilter"
                    type="text"
                    class="form-control"
                    :placeholder="$t('administration.enter_company_name')"
                    :aria-label="$t('filter.search_by') + ' ' + $t('administration.user')">
                </div>
              </b-col>
            </b-row>
            
            <!-- Boutons d'action -->
            <b-row class="gx-2">
              <b-col cols="6">
                <app-button
                  :text="$t('filter.clr_fltr_field')"
                  icon="fa-light fa-eraser"
                  variant="secondary"
                  outline
                  :block="true"
                  :aria-label="$t('filter.clr_fltr_field')"
                  @click="clearFilterFields"
                  :disabled="!hasInputFilter || activateSpinner"
                />
              </b-col>
              <b-col cols="6">
                <app-button
                  :text="$t('common.srch')"
                  icon="fa-light fa-magnifying-glass"
                  variant="primary"
                  :block="true"
                  :aria-label="$t('common.srch') + ' ' + $t('Webheader.company')"
                  @click="applyFilter"
                  :loading="activateSpinner"
                  :loadingText="$t('common.rfrsh')"
                />
              </b-col>
            </b-row>
          </div>
        </b-collapse>
      </div>
    </template>
    
    <template slot="pageContent">
      <!-- <div class="layoutTop"></div> -->
      <div class="overflow-hidden">
        <b-row class="no-gutters">
          <b-col md="12">
            <div class="requestsList">
              <div class="mt-0">
                <spinner v-if="activateSpinner"></spinner>
                <div v-else class="overflow-x-unset">
                  <b-table v-if="CompaniesList.length" hover
                  class="mt-3"
                  :items="CompaniesList"
                  :fields="companyFields"
                  :selectable="CompaniesList.length > 0"
                  :empty-text="$t('common.security.no_result')"
                  @row-selected="seeCompanyDetails">
                    <template #cell(active)="data">
                      <div v-if="data.value === '0'"><i class="fa-duotone fa-xmark btn btn-icon btn-icon-red"></i></div>
                      <div v-else-if="data.value === '1'"><i class="fa-duotone fa-warning btn btn-icon btn-icon-orange"></i></div>
                      <div v-else-if="data.value === '2'"><i class="fa-duotone fa-check btn btn-icon btn-icon-green"></i></div>
                    </template>
                    <template #cell(edit)="data">
                      <span class="text-center d-inline-block py-4 w-100" @click="activateEdit($event, data.value)"><i class="fa-regular fa-pencil"></i></span>
                    </template>
                    <template #cell(delete)="data">
                      <span class="text-center d-inline-block py-4 w-100" @click="activateDelete($event, data.value)"><i class="fa-light fa-trash"></i></span>
                      <span></span>
                    </template>
                  </b-table>
                  <!-- ANCIENNE TABLE DRO 16/08/2023
                  <table class="table mt-3 text-center" v-if="CompaniesList.length">
                    <thead>
                      <tr>
                        <th class="text-center">
                          {{ $t('administration.active_enable') }}
                        </th>
                        <th class="text-center">
                          {{ $t('common.idtfr') }}
                        </th>
                        <th class="text-center">
                          {{ $t('common.user') }}
                        </th>
                        <th class="text-center">
                          {{ $t('common.eml_adrs') }}
                        </th>
                        <th v-if="canUserEditCompagny" class="text-center">
                          {{ $t('rights.edit') }}
                        </th>
                        <th v-if="canUserDeleteCompagny" class="text-center">
                          {{ $t('common.del_label') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="result in CompaniesList" :key="result.index" class="boxRequest line-hover">
                        <td class="text-center" @click="activateDetail(result.id_account)">
                          <div v-if="result.active ==='0'"><i class="fa-duotone fa-xmark btn btn-icon btn-icon-red"></i></div>
                          <div v-else-if="result.active === '1'"><i class="fa-duotone fa-warning btn btn-icon btn-icon-orange"></i></div>
                          <div v-else-if="result.active === '2'"><i class="fa-duotone fa-check btn btn-icon btn-icon-green"></i></div>
                        </td>
                        <td class="text-center" @click="activateDetail(result.id_account)">{{ result.identifier }}</td>
                        <td class="text-center" @click="activateDetail(result.id_account)">{{ result.name }}</td>
                        <td class="text-center" @click="activateDetail(result.id_account)">{{ result.email_reference }}</td>
                        <td v-if="canUserEditCompagny" @click="activateEdit(result.id_account)"><i class="fa-light fa-pencil cursor"></i></td>
                        <td v-if="canUserDeleteCompagny" @click="activateDelete(result.id_account)"><i class="fa-light fa-trash"></i></td>
                      </tr>
                    </tbody>
                  </table>-->

                  <div v-else class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('common.no_result') }}
                    </span>
                  </div>

                  <b-row class="justify-content-end mt-3 no-gutters">
                    <b-button class="mt-3" v-if="canUserAddCompagny"
                    @click="addCompany" variant="primary">
                      <i class="fa-light fa-plus fs-17px"></i>
                      <span>{{$t('administration.company_add')}}</span>
                    </b-button>
                  </b-row>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment-timezone'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import PageOutline from '@/components/common/PageOutline.vue'
import AppButton from '@/components/common/AppButton.vue'
import { downloadFileWithDefinedHeaders } from '@/helpers/download'


export default {
  name: 'Companies',
  components: {
    'cm-pagination': Pagination,
    'spinner': Spinner,
    'page-outline': PageOutline,
    'app-button': AppButton
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    direction: {
      default: '2',
      type: String
    },
    redirection: { /*props redirection activé si = 1. Défini si redirection lorsque nous avons qu'une seule entrerprise DRO 15/01/2024*/
      default: '0',
      type: String
    }
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    companyFields() {
      let fields = [
        { key: 'identifier', label: this.$t('common.idtfr'), class:'text-center', sortable: true },
        { key: 'name', label: this.$t('common.user'), class:'text-center', sortable: true },
        { key: 'email_reference', label: this.$t('common.eml_adrs'), class:'text-center', sortable: true },
      ]
      if(this.canUserEditCompagny) {
      fields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center', tdClass: 'p-0'})
      }
      if(this.canUserDeleteCompagny) {
        fields.push({ key: 'delete', label: this.$t('common.del_label'), thClass: 'text-center', tdClass: 'p-0'})
      }
      return fields
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    emailReferenceDirection () {
      return ((this.sortField === 'email_reference' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    identifierDirection () {
      return ((this.sortField === 'identifier' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    nameDirection () {
      return ((this.sortField === 'name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    listTitle () {
      return this.$t('Webheader.company')
    },
    hasInputFilter () {
      if (
        this.active ||
        this.identifier ||
        this.name) {
        return true
      }
      return false
    },
    canUserAddCompagny() {
      return this.$engine.firstOn().rights.rightIs('company_add', true) || this.$engine.firstOn().rights.rightIs('company_add_admin', true)
    },
    canUserEditCompagny () {
      return this.$engine.firstOn().rights.rightIs('company_edit', true) || this.$engine.firstOn().rights.rightIs('company_edit_admin', true)
    },
    canUserDeleteCompagny () {
      return this.$engine.firstOn().rights.rightIs('company_delete', true) || this.$engine.firstOn().rights.rightIs('company_delete_admin', true)
    }
  },
  data () {
    return {
      activateSpinner: false,
      active: '',
      identifier: '',
      filterBy: '',
      name: '',
      CompaniesList: [],
      idCompany: '',
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      displayFilter: false,
      hasDefaultFilter: false,
      timer: '',
      timezone: '+00:00'
    }
  },
  created () {
    this.timezone = moment.tz.guess()
    this.$engine.firstOn().company.redirection = this.redirection //stockage redirection du path dans l'engine pour qu'il soit réutilisé DRO 16/01/2024
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Entreprise',
      returnUrl: ''
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 13
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$engine.firstOn().settings.set({msgDirection: this.direction})
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })
    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
    let defaultFilter = this.$engine.firstOn().company.getDefaultFilter()
    this.setDefaultFilter(defaultFilter)
  },
  beforeDestroy () {
    let that = this
    that.$engine.firstOn().company.cleanFilterCondition()
  },
  methods: {
    applyFilter (filterConditions = {}) {
      let that = this
      clearTimeout(this.timer)
      let defaultFilter = this.$engine.firstOn().company.getDefaultFilter()
      this.filterTypeGet = 'list'
      this.setDefaultFilter(defaultFilter)
      this.$engine.firstOn().company.cleanFilterCondition()
      this.$engine.firstOn().company.active = this.active
      this.$engine.firstOn().company.identifier = this.identifier
      this.$engine.firstOn().company.name = this.name

      for (let propertyCustom in filterConditions) {
        this.$engine.firstOn().company[propertyCustom] = filterConditions[propertyCustom]
      }
      filterConditions = this.$engine.firstOn().company.getConditionObject()
      // this.$emit('applyFilter', actualFilter.getConditionObject())

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      this.activateSpinner = true
      this.$engine.firstOn().company.getCompanies(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResults = resp.data.companies.length
        resp.data.companies.forEach(item => {
          item.email_reference = item.account.email_reference
          item.active = item.account.active
          item.identifier = item.account.identifier
          item.name = item.account.name
          item.id_account = item.account.id_account
        })
        requests = resp.data.companies
        that.updateInbox(requests)
        // this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    delayApplyFilter() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.applyFilter()
      }, 1500)
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      this.active = ''
      this.identifier = ''
      this.name = ''
      this.communicateChange()
      // this.applyFilter()
    },
    toggleFilter () {
      this.displayFilter = !this.displayFilter
    },
    deleteFilter () {
      this.$engine.firstOn().company.saveDefaultFilter({})
      this.hasDefaultFilter = false
      this.$f7.modal({
        title: 'Filtre supprimé',
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    saveDefaultFilter () {
      let that = this

      let defaultFilter = {
        active: this.active,
        identifier: this.identifier,
        name: this.name
      }

      this.$engine.firstOn().company.saveDefaultFilter(defaultFilter)

      if (this.hasInputFilter) {
        this.hasDefaultFilter = true
      }

      that.$f7.modal({
        title: this.$i18n.t('filter.dflt_fltr_svd'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    seeCompanyDetails (items) {
      this.activateDetail(items[0].id_account)
      this.$engine.firstOn().company.redirection = '0'
    },
    setDefaultFilter (defaultFilter) {
      for (const property in defaultFilter) {
        this[property] = defaultFilter[property]
        if (defaultFilter[property]) {
          this.hasDefaultFilter = true
        }
      }
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        // this.$$('.infinite-scroll').append(
        // '<div class="infinite-scroll-preloader"><div class="preloader"></div></div>'
        // )
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.firstOn().settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.firstOn().settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    exportCompany () {
      this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
      let firstLine = 'Adresse email' + ';' +
        'Active' + ';' +
        'Nom' + ';' +
        'Identifiant' + ';' + '\r\n'
      let lines = ''
      for (var i = 0; i < this.CompaniesList.length; i++) {
        let result = this.CompaniesList[i]
        let iconActive
        if (result.active === "0") {
          iconActive = this.$t('administration.no')
        } else if (result.active === "1") {
          iconActive = this.$t('administration.in_prgrss')
        } else if (result.active === "2") {
          iconActive = this.$t('administration.yes')
        }
        lines += result.email_reference + ';' +
                 iconActive + ';' +
                 result.name + ';' +
                 result.identifier + ';' + '\r\n'
      }
      let data = firstLine + lines
      this.$f7.hidePreloader()
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      let today = moment().tz(this.timezone)
      let fileName = 'company_' + today.unix() + '.csv'
      if (
      this.$f7.device.os === 'android' ||
      this.$f7.device.os === 'ios'
      ) {
        downloadFileWithDefinedHeaders(this, fileName, linkSource)
      } else {
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      }
      this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onInfinite () {
      if (this) {
        return
      }
      if (this.scrollFlag) {
        this.scrollFlag = false
        let that = this
        this.pageCounter = this.pageCounter + 1
        this.paginationObject['firstIndex'] = this.pageCounter * this.paginationObject['maxResults'] + 1
        this.paginationObject['nbResultsTotal'] = 0

        let filterConditions
        if (this.$engine.firstOn().company.getDefaultFilter()) {
          filterConditions = this.$engine.firstOn().company.getDefaultFilter()
        } else {
          filterConditions = this.$engine.firstOn().company.getConditionObject()
        }
        filterConditions.sortField = 'SF' + this.sortField
        filterConditions.sortDirection = this.sortDirection
        this.$engine.firstOn().company.getCompanies(
          this.paginationObject['maxResults'],
          this.paginationObject['firstIndex'],
          filterConditions
        ).then(resp => {
          let requests = {}
          that.requestsNumber = resp.data.companies.length
          resp.data.companies.forEach(item => {
            item.email_reference = item.account.email_reference
            item.active = item.account.active
            item.identifier = item.account.identifier
            item.name = item.account.name
            item.id_account = item.account.id_account
          })
          requests = resp.data.companies
          that.paginationObject.nbResults = that.requestsNumber

          if (requests.length > 0) {
            for (let i = 0; i < requests.length; i++) {
              that.CompaniesList.push(requests[i])
            }
            if (requests.length < this.paginationObject['maxResults']) {
              that.detachInfinit()
            }
          } else {
            that.detachInfinit()
          }
          that.scrollFlag = true
        })
        .catch(error => {
          errorMessageAlert(error, that, that.$i18n)
          that.scrollFlag = true
        })
      }
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      // this.scrollFlag = true
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions
      if (this.$engine.firstOn().company.getDefaultFilter()) {
        filterConditions = this.$engine.firstOn().company.getDefaultFilter()
      } else {
        filterConditions = this.$engine.firstOn().company.getConditionObject()
      }
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      this.$engine.firstOn().company.getCompanies(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResults = resp.data.companies.length
        if(this.redirection === '1' && resp.data.companies.length === 1) {
          this.activateDetail(resp.data.companies[0].account.id_account)
        } else {
          resp.data.companies.forEach(item => {
            item.email_reference = item.account.email_reference
            item.active = item.account.active
            item.identifier = item.account.identifier
            item.name = item.account.name
            item.id_account = item.account.id_account
            item.edit = item.account.id_account
            item.delete = item.account.id_account
            // item.typeAction = this.$t('company.' + item.typeAction)
          })
          requests = resp.data.companies
          that.updateInbox(requests, noAttach)
          that.$f7.pullToRefreshDone()
          that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        }
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    /* activateDetail (ressource) {
      this.$bus.emit('id_account-info', ressource)
      this.$f7.popup('#show-detail-true')
      this.$bus.off('id_account-info', ressource)
    }, */
    activateDetail (ressource) {
      // let that = this
      // this.idCompany = ressource
      /* this.$bus.$emit('call_company_details', ressource)
      setTimeout(function () {
        reloadPage2(that, '/detail/')
      }, 1000) */
      let that = this
      loadPage(that, {url: '/detail/' + ressource})
    },
    activateEdit ($e, ressource) {
      let that = this
      $e.stopPropagation() //AJOUTER EN PARAMETRE "$e"
      this.$engine.firstOn().company.redirection = '0'
      loadPage(that, {url: '/editcompany/' + ressource})
    },
    refreshInbox () {
      this.onRefresh()
    },
    activateDelete ($e, ressource) {
      let that = this
      $e.stopPropagation()
      if (ressource === this.$engine.firstOn().user.get().id) {
        that.$f7.modal({
          title: this.$i18n.t('administration.del_company_impbl'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      } else {
        this.$f7.modal({
          title: this.$i18n.t('administration.del_company_qt'),
          buttons: [
            {
              text: this.$t('creation_forms.vldt'),
              onClick: function () {
                that.$engine.firstOn().company.deleteCompany(ressource)
                .then(resp => {
                  that.$f7.alert('', that.$t('administration.del_company'))
                  that.onRefresh(false)
                })
              }
            },
            {
              text: this.$t('common.cncl'),
              onClick: function () {
                return
              }
            }
          ]
        })
      }
    },
    addCompany () {
      let that = this
      loadPage(that, {url: '/addcompany/'})
    },
    reOrderBy (column) {
      let that = this
      if (this.sortField === column) {
        // just switch order
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        // new column + default order
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions
      if (this.$engine.firstOn().company.getDefaultFilter()) {
        filterConditions = this.$engine.firstOn().company.getDefaultFilter()
      } else {
        filterConditions = this.$engine.firstOn().company.getConditionObject()
      }
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      this.$engine.firstOn().company.getCompanies(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResults = resp.data.companies.length
        resp.data.companies.forEach(item => {
          item.email_reference = item.account.email_reference
          item.active = item.account.active
          item.identifier = item.account.identifier
          item.name = item.account.name
          item.id_account = item.account.id_account
        })
        requests = resp.data.companies
        that.updateInbox(requests, false)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    updateInbox (requests, noAttach = false) {
      this.CompaniesList = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    showButtonImportLot () {
      // Service RTP import lot identifiant?
      return false
    },
    importAccount () {
      this.$bus.$emit('popup-import-companies')
    }
  }
}
</script>
